import { render, staticRenderFns } from "./IconLibrary.vue?vue&type=template&id=f4b8070e&scoped=true&"
import script from "./IconLibrary.vue?vue&type=script&lang=js&"
export * from "./IconLibrary.vue?vue&type=script&lang=js&"
import style0 from "./IconLibrary.vue?vue&type=style&index=0&id=f4b8070e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b8070e",
  null
  
)

export default component.exports